(function() {
    'use strict';

    angular.module('settings')
        .controller('BannerUpdateController', BannerUpdateController);

    BannerUpdateController.$inject = ['$state', 'bannerDataSrvc', 'notificationSrvc', 'bannerMessagesConst', 'productCountryConst', 'pageDataSrvc', 'errorNotificationSrvc'];

    function BannerUpdateController($state, bannerDataSrvc, notificationSrvc, bannerMessagesConst, productCountryConst, pageDataSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            url: [],
            is_published: [],
            datetime_from: [],
            datetime_to: [],
            display_time: [],
            available_in_countries: [],
            pages: [],
            image: [],
            description_pl: [],
            description_de: [],
            description_en: [],
            description_cpde: [],
            description_cpen: [],
            nonFieldErrors: []
        };
        self.bannerData = {};

        self.countryList = productCountryConst;
        self.pagesList = [];

        self.updateBanner = updateBanner;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getPages();
            getBanner();
        }

        function getPages() {
            return pageDataSrvc.bannerPages()
                .$promise.then(function(response) {
                    self.pagesList = response;
                    return response;
                });
        }

        function getBanner() {
            return bannerDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.bannerData = response;

                delete self.bannerData.date_modified;
                delete self.bannerData.date_added;
                return response;
            });
        }

        function updateBanner() {
            bannerDataSrvc.update({
                pk: self.bannerData.pk
            }, self.bannerData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", bannerMessagesConst.update);
                    $state.go('layout.banner.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
